import React from "react";
import {
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Inject as ChartInject,
  AccumulationLegend,
  AccumulationTooltip,
  AccumulationDataLabel,
  AccumulationAnnotation,
  PieSeries,
} from "@syncfusion/ej2-react-charts";
import { Box, Card, CardContent, Divider, Typography } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";
import { QUDA_COLORS } from "@/config/colors";

const PieChart = ({
  title = "Order Types",
  data = [],
  height = "100%",
  width = "100%",
  showCenterLabel = true,
  borderColor = QUDA_COLORS.TEAL_DARK,
  titleColor = QUDA_COLORS.TEAL_DARK,
  iconColor = QUDA_COLORS.TEAL_DARK,
  dividerColor = QUDA_COLORS.TEAL_LIGHT,
  minHeight = 300,
}) => {
  return (
    <Box
      sx={{
        border: `2px solid ${borderColor}`,
        borderRadius: "8px",
        overflow: "hidden",
        height: "100%",
        minHeight: minHeight,
      }}
    >
      <Card sx={{ height: "100%", boxShadow: "none" }}>
        <CardContent sx={{ height: "100%" }}>
          <Box className="flex items-center space-x-2 mb-4">
            <ShoppingCart sx={{ color: iconColor }} />
            <Typography
              variant="h6"
              className="font-bold"
              sx={{ color: titleColor }}
            >
              {title}
            </Typography>
          </Box>
          <Divider sx={{ mb: 2, borderColor: dividerColor }} />
          <div
            style={{
              height: "calc(100% - 60px)",
              minHeight: 200,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {data.length > 0 ? (
              <AccumulationChartComponent
                id={`pie-chart-${title.replace(/\s+/g, '-').toLowerCase()}`}
                width="100%"
                height="100%"
                enableSmartLabels={true}
                tooltip={{ enable: true }}
                legendSettings={{
                  visible: true,
                  position: "Bottom",
                  shapeHeight: 15,
                  shapeWidth: 15,
                  toggleVisibility: false,
                  padding: 10,
                }}
                tooltipRender={(args) => {
                  const percentage = args.point.percentage.toFixed(2);
                  args.text = `${args.point.x}: ${args.point.y} (${percentage}%)`;
                }}
                centerLabel={
                  showCenterLabel
                    ? {
                        text:
                          "Total:\n" +
                          data.reduce((sum, item) => sum + item.y, 0),
                        textStyle: {
                          fontWeight: "600",
                          size: "14px",
                          color: "#333",
                        },
                      }
                    : undefined
                }
              >
                <ChartInject
                  services={[
                    PieSeries,
                    AccumulationLegend,
                    AccumulationTooltip,
                    AccumulationDataLabel,
                    AccumulationAnnotation,
                  ]}
                />
                <AccumulationSeriesCollectionDirective>
                  <AccumulationSeriesDirective
                    dataSource={data}
                    xName="x"
                    yName="y"
                    radius="90%"
                    startAngle="270"
                    endAngle="90"
                    pointColorMapping="color"
                    type="Pie"
                    innerRadius="60%"
                    explode={false}
                    explodeOffset="5%"
                    explodeIndex={1}
                    border={{
                      width: 2,
                      color: "white",
                    }}
                    borderRadius={8}
                    dataLabel={{
                      visible: false,
                    }}
                  />
                </AccumulationSeriesCollectionDirective>
              </AccumulationChartComponent>
            ) : (
              <Typography
                variant="body2"
                color="textSecondary"
                className="text-center"
              >
                No data available
              </Typography>
            )}
          </div>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PieChart;
